import { render, staticRenderFns } from "./initAssessment.vue?vue&type=template&id=53e51492&scoped=true&"
import script from "./initAssessment.vue?vue&type=script&lang=ts&"
export * from "./initAssessment.vue?vue&type=script&lang=ts&"
import style0 from "./initAssessment.vue?vue&type=style&index=0&id=53e51492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e51492",
  null
  
)

export default component.exports